import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useEffect, Fragment } from "react";
import { StatusNumber } from "../../helper/statusNumber";
import { useQuoteContext } from "../../shared/contexts/QuoteContext";
import { DecisionTree, DecisionTreeQuestion, QuotePackage, QuoteProduct } from "../../shared/types/quotes";
import DocumentDownload from "../DocumentDownload";
import DownloadAllDocuments from "../DownloadAllDocuments";
import { DocumentType } from "../../helper/enum/DocumentType";
import { useGetWordingsByQuoteIdListQuery } from '../../services/features/documentsApi/documentsApi';
import { NonApplicablePolicyDocuments } from "../../helper/nonApplicableDocuments";

const DownloadQuotesTable = (props: any) => {
	const {
		currentQuotes,
		isDeclined,
		needsReferral,
		isReferralApproved,
		isReferred,
        isQuoteBound,
	} = useQuoteContext();

	const { data: quoteUrls } = useGetWordingsByQuoteIdListQuery(currentQuotes.map(quote => quote.id), {
		skip: currentQuotes.length === 0,
	});

    const isDisabled = (!isReferralApproved && needsReferral) ||
    isReferred ||
    isDeclined;

	return (
		<TableContainer sx={{ my: "1em" }}>
			<Table>
				<TableHead>
					<TableRow
						sx={{ "& .MuiTableCell-root": { fontWeight: 700, fontSize: "12px" } }}
					>
						<TableCell colSpan={2}>PRODUCT</TableCell>
						<TableCell align="right">
							<DownloadAllDocuments
								// quoteIds={currentQuotes.map((quote) => quote.id)}
								disabled={!isQuoteBound && isDisabled}
							/>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{currentQuotes?.map((quote) => {
						let productName = '';
						if ((quote.quoteProducts ?? []).length > 0) {
							productName = quote.quoteProducts[0].name;
						} else if ((quote.quotePackages ?? []).length) {
							productName = quote.quotePackages[0].name;
						}
						const wordings = (quoteUrls?.[quote.id] ?? []).filter(
							(w) => w?.policyWordingUrl.length > 0
						);

						console.log('policy wording', {
							wordings,
							quoteId: quote.id,
							quoteUrls,
						});

						return (
							<Fragment key={`table-rows-quote-${quote.id}`}>
								<TableRow hover key={`quote-${quote.id}`}>
									<TableCell colSpan={3}>{productName}</TableCell>
								</TableRow>
								<TableRow hover key={`record-of-answers-${quote.id}`}>
									<TableCell component='th' scope='row' padding='checkbox' />
									<TableCell component='th' scope='row' padding='none'>
										Record of Answers (PDF)
									</TableCell>
									<TableCell align='right'>
										<DocumentDownload
											quoteDataId={quote.id}
											type={DocumentType.DecisionTree}
											disabled={!isQuoteBound && isDisabled}
										/>
									</TableCell>
								</TableRow>
								<TableRow hover key={`quote-document-${quote.id}`}>
									<TableCell component='th' scope='row' padding='checkbox' />
									<TableCell component='th' scope='row' padding='none'>
										Quote Document (PDF)
									</TableCell>
									<TableCell align='right'>
										<DocumentDownload 
											quoteDataId={quote.id} 
											type={DocumentType.Quote}
											disabled={!isQuoteBound && isDisabled}
										/>
									</TableCell>
								</TableRow>

								{wordings?.map((wording, index) => (
									<TableRow
										hover
										key={`policy-wording-policy-${wording.policyWordingName}-${index}`}
									>
										<TableCell
											component='th'
											scope='row'
											padding='checkbox'
										/>
										<TableCell component='th' scope='row' padding='none'>
											<span>
												<span
													style={{ paddingRight: '0.25em' }}
												>{`${wording.productName}`}</span>
												<span>{'Policy wording (PDF)'}</span>
											</span>
										</TableCell>
										<TableCell align='right'>
											<DocumentDownload 
												quoteDataId={quote.id}
												type={DocumentType.Wording}
												wording={wording}
												disabled={!isQuoteBound && isDisabled}
											/>
										</TableCell>
									</TableRow>
								))}
							</Fragment>
						);
					})}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default DownloadQuotesTable;
